import {
    addBillingAddress,
    addLoyaltyCardNumber,
    addShippingAddress,
    applyGiftcard,
    cleanCost,
    getShippingMethods,
    recalculateCart,
    removeGiftcard,
    removePaymentCost,
    replicateCart,
    setPaymentCost,
    setShippingCost,
    validateCart,
} from "@/lib/jog"
import { CartStore } from "@jog/react-components"

const store = new CartStore({
    api: {
        recalculateCart,
        addBillingAddress,
        addShippingAddress,
        getShippingMethods,
        setShippingCost,
        applyGiftcard,
        removeGiftcard,
        replicateCart,
        setPaymentCost,
        removePaymentCost,
        addLoyaltyCardNumber,
        validateCart,
        cleanCost,
    },
})

export default store
